export default __webpack_public_path__ + "images/a258a6be866de663b1b1c5b3ad353040-fighting_martial_arts.jpg";